var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"GJEmpower",attrs:{"id":"app"}},[_c('div',{staticClass:"closeButton",on:{"click":_vm.closeGJEmpower}},[_c('i',{staticClass:"el-icon-close"})]),_c('iframe',{staticStyle:{"border":"none","overflow":"hidden","margin-top":"30px"},attrs:{"width":_vm.searchTableWidth,"height":_vm.searchTableHeight,"src":_vm.reportUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }